/**
 * "Your vehicle" on the store (PDP layout phase 2, 2026-09-24).
 *
 * The catalogue remembers the rider's vehicle in its own storage and hands it
 * to the store on the way over, as ?kxv=<catalog model id> on the followed link
 * only (catalog vehicle-pin.js). This script keeps it in the store's own
 * storage (no cookies), removes the parameter from the address bar, shows a
 * slim vehicle bar under the header and, on a product page, asks the
 * catalogue whether this part number fits that exact vehicle (model, year and
 * colour: /api/vehicle-fit answers from the vehicle's own diagrams).
 * Nothing renders when no vehicle is known or the catalogue does not answer.
 */
;(function () {
	var KEY = 'kx-vehicle'
	var API = 'https://catalog.kymcopartsstore.com/api/vehicle-fit'
	var CATALOG = 'https://catalog.kymcopartsstore.com/'
	var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

	var save = function (v) {
		try {
			if (v) localStorage.setItem(KEY, JSON.stringify(v))
			else localStorage.removeItem(KEY)
		} catch (e) { /* storage disabled: nothing is remembered */ }
	}
	var load = function () {
		try { return JSON.parse(localStorage.getItem(KEY) || 'null') } catch (e) { return null }
	}

	// 1. A vehicle handed over by the catalogue link.
	var params = new URLSearchParams(location.search)
	var handed = params.get('kxv')
	if (handed !== null) {
		if (UUID.test(handed)) {
			var before = load()
			save({ id: handed, label: before && before.id === handed ? before.label : null })
		}
		params.delete('kxv')
	}

	// 1b. The catalogue page the rider came from (?kxs=<path>, 2026-09-26): a
	// model, year or diagram page. The product page's "See <number> on the
	// exploded diagram" button then opens the part on THAT machine
	// (catalog /diagram/<number>?in=<path>) instead of the newest model that
	// shares the number. Kept per product for the tab (sessionStorage), so a
	// reload still knows; a product reached any other way uses the default.
	var SCOPE = /^\/(?:models\/[a-z0-9-]+(?:\/[a-z0-9-]+)?|families\/[a-z0-9-]+\/[a-z0-9-]+(?:\/[0-9a-z+-]+)?)$/
	var SCOPE_KEY = 'kx-came-from'
	var cameFrom = params.get('kxs')
	if (cameFrom !== null) {
		if (SCOPE.test(cameFrom)) {
			try { sessionStorage.setItem(SCOPE_KEY, JSON.stringify({ page: location.pathname, path: cameFrom })) } catch (e) { /* not remembered */ }
		}
		params.delete('kxs')
	}
	if (handed !== null || cameFrom !== null) {
		var q = params.toString()
		try { history.replaceState(history.state, '', location.pathname + (q ? '?' + q : '') + location.hash) } catch (e) { /* keep the URL */ }
	}
	var cta = document.querySelector('[data-kx-diagram-cta]')
	var ctaScoped = false
	if (cta) {
		var from = null
		try { from = JSON.parse(sessionStorage.getItem(SCOPE_KEY) || 'null') } catch (e) { /* none */ }
		var ctaNumber = cta.getAttribute('data-number')
		if (from && from.page === location.pathname && SCOPE.test(from.path || '') && ctaNumber) {
			cta.href = CATALOG + 'diagram/' + encodeURIComponent(ctaNumber) + '?in=' + encodeURIComponent(from.path)
			ctaScoped = true
		}
	}

	var vehicle = load()
	if (!vehicle || !UUID.test(vehicle.id || '')) return

	var el = function (tag, cls, text) {
		var node = document.createElement(tag)
		if (cls) node.className = cls
		if (text) node.textContent = text
		return node
	}
	var link = function (href, text, cls) {
		var a = el('a', cls, text)
		a.href = href
		return a
	}

	// 2. The vehicle bar.
	var slot = document.getElementById('kx-vehicle-bar')
	var box = document.querySelector('[data-kx-fit]')
	var drawBar = function (v) {
		if (!slot || !v.label) return
		// Same pill as the catalogue's vehicle-pin.js (owner 2026-09-25): pin
		// glyph, small caps label, the vehicle (links to its catalogue page,
		// which is also where another vehicle is picked) and "forget".
		var inner = slot.querySelector('.kx-vehicle-bar__inner')
		inner.textContent = ''
		var pill = el('p', 'kx-vehicle-bar__pill')
		var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
		icon.setAttribute('class', 'kx-vehicle-bar__icon')
		icon.setAttribute('viewBox', '0 0 24 24')
		icon.setAttribute('aria-hidden', 'true')
		icon.innerHTML = '<path d="M12 21s-6.5-5.6-6.5-11a6.5 6.5 0 0 1 13 0c0 5.4-6.5 11-6.5 11Z"/><circle cx="12" cy="10" r="2.4"/>'
		pill.appendChild(icon)
		pill.appendChild(el('span', 'kx-vehicle-bar__tag', 'Your vehicle: '))
		pill.appendChild(link(v.url || CATALOG + 'models/' + v.id, v.label, 'kx-vehicle-bar__name'))
		var forget = el('button', 'kx-vehicle-bar__forget', 'forget')
		forget.type = 'button'
		forget.setAttribute('aria-label', 'Forget my vehicle')
		forget.addEventListener('click', function () {
			save(null)
			slot.hidden = true
			if (box) box.hidden = true
		})
		pill.appendChild(forget)
		inner.appendChild(pill)
		slot.hidden = false
	}
	drawBar(vehicle)

	// 3. The fit box on a product page.
	// KYMCO joins assembly names with a bullet ("Cylinder Head Cover ● Cylinder
	// Head"); in a sentence it reads as a slash, as on the catalog model pages.
	var sectionName = function (d) { return d.code + ' ' + String(d.name || '').replace(/\s*[●•]\s*/g, ' / ') }
	var drawFit = function (v, fit) {
		if (!box || !fit) return
		box.textContent = ''
		box.className = 'kx-vfit ' + (fit.fits ? 'kx-vfit--yes' : 'kx-vfit--no')
		var mark = el('span', 'kx-vfit__mark', fit.fits ? '✓' : '!')
		mark.setAttribute('aria-hidden', 'true')
		box.appendChild(mark)
		var body = el('div', 'kx-vfit__body')
		body.appendChild(el('p', 'kx-vfit__title', (fit.fits ? 'Fits your ' : 'Not listed for your ') + v.label))
		var sub = el('p', 'kx-vfit__sub')
		if (fit.fits && fit.diagram) {
			sub.appendChild(document.createTextNode('Checked on the ' + sectionName(fit.diagram) + ' diagram of your vehicle. '))
			sub.appendChild(link(fit.diagram.url, 'See it on your diagram'))
			// No page to come back to: the diagram button follows the vehicle.
			if (cta && !ctaScoped) cta.href = fit.diagram.url
		} else if (fit.diagram) {
			sub.appendChild(document.createTextNode('The ' + sectionName(fit.diagram) + ' diagram of your vehicle shows the number that fits it. '))
			sub.appendChild(link(fit.diagram.url, 'Open your diagram'))
		} else {
			sub.appendChild(document.createTextNode('This part is not on any diagram of your vehicle. '))
			sub.appendChild(link(v.url, 'Browse your vehicle’s diagrams'))
		}
		body.appendChild(sub)
		box.appendChild(body)
		box.hidden = false
	}

	var number = box ? box.getAttribute('data-number') : ''
	var url = API + '?model=' + encodeURIComponent(vehicle.id) + (number ? '&number=' + encodeURIComponent(number) : '')
	fetch(url, { credentials: 'omit' })
		.then(function (r) {
			if (r.status === 404) {
				save(null)
				if (slot) slot.hidden = true
				return null
			}
			return r.ok ? r.json() : null
		})
		.then(function (data) {
			if (!data || !data.vehicle) return
			var v = { id: data.vehicle.id, label: data.vehicle.label, url: data.vehicle.url }
			save(v)
			drawBar(v)
			drawFit(v, data.fit)
		})
		.catch(function () { /* the catalogue did not answer: show nothing new */ })
})()
